import SVGDrawer from './svg-drawer';
import HTMLDrawer from './html-drawer';
import QRCode from './qr-code';

function hasSVG() {
  try {
    return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
  } catch (_) {
    return false;
  }
}

function hasCanvas() {
  return typeof CanvasRenderingContext2D != 'undefined';
}

let Drawer;
if (hasSVG()) {
  Drawer = SVGDrawer;
} else {
  Drawer = HTMLDrawer;
}

const defaultOptions = {
  width: 100,
  height: 100,
  colorLight: '#fff',
  colorDark: '#000'
};

export default function draw(element, options) {
  const drawer = new Drawer(element, Object.assign({}, defaultOptions, options));
  const code = new QRCode(options.text, options.level);
  drawer.draw(code);
  drawer.makeImage && drawer.makeImage();
}

export { default as makeCode } from './qr-code';
export { ErrorCorrectLevel as CorrectLevel } from './constants';
